<template>
  <nav v-if="list.length" class="breadcrumbs">
    <ul>
      <li v-for="(route, i) in list" :key="i">
        <strong v-if="i === list.length - 1" class="active">
          {{ route.label }}
        </strong>
        <router-link
          v-else
          :to="route.path"
          active-class="active"
        >
          {{ route.label }}
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "AdminBreadcrumbs",
  props: {
    labels: {
      type: Array,
      default: undefined,
    },
  },
  data() {
    return {
      list: [],
    }
  },
  watch: {
    $route() {
      this.setLevels()
    },
    labels() {
      this.setLevels()
    },
  },
  created() {
    this.setLevels()
  },
  methods: {
    link(router) {
      let path = ""
      Object.keys(this.$route.params).forEach((e) => {
        path = router.path.replace(`:${e}`, this.$route.params[e])
      }, this)

      return path
    },
    setLabels(index) {
      return this.labels.length - 1 >= index ? this.labels[index] : false
    },
    setLevels() {
      const vm = this
      const list = []
      let i = 0

      vm.$route.matched.forEach((router) => {
        if (router.meta.breadcrumb) {
          list.push({
            label: this.setLabels(i) || router.meta.breadcrumb,
            path: this.link(router),
          })

          i += 1
        }
      })

      vm.list = list
    },
  },
}
</script>

<style></style>
